import { MembranePrediction } from "constants/constantStrings";

const getDaysFormatted = value => {
  let message = null;
  if (value >= 13) {
    message = MembranePrediction.membranePredictionCleaningDays.replace("% Months", "over a year");
  } else {
    message = MembranePrediction.membranePredictionCleaningDays.replace("%", value);
  }
  return message;
};

const appendUnit = (variable, unit) => {
  // console.log("unit",unit)
  if (unit === "US") {
    return `${variable} (psi)`;
  } else {
    return `${variable} (bar)`;
  }
};
const MembranePredictionData = value => [
  {
    variable: MembranePrediction.conductivity,
    cc: value.CIT3_RMNG_cycles_BF_MemRep,
    proposedCleaning: getDaysFormatted(value.CIT3_RMNG_months_BF_MemRep),
    threshold: value.CIT3_threshold,
    currentvalue: value.CIT3_current_value
  },
  {
    variable: appendUnit(MembranePrediction.pt2, value.units),
    cc: value.PT2_RMNG_cycles_BF_MemRep,
    proposedCleaning: getDaysFormatted(value.PT2_RMNG_months_BF_MemRep),
    threshold: value.PT2_Threshold,
    currentvalue: value.PT2_current_value
  },
  {
    variable: appendUnit(MembranePrediction.dp, value.units),
    cc: value.DP_RMNG_cycles_BF_MemRep,
    proposedCleaning: getDaysFormatted(value.DP_RMNG_months_BF_MemRep),
    threshold: value.DP_threshold,
    currentvalue: value.DP_current_value
  }
];

export const MembranePredictionsData = value => MembranePredictionData(value);
